


















































































































import { defineComponent } from '@vue/composition-api'
import useSalary from '@/modules/salary'
// reason why I made index.ts in components folder for cleaner import
import {
  InputComponent,
  SubmitButton,
  Container,
  AppHeader,
  DropDown,
  Radio
} from '@/components'

export default defineComponent({
  name: 'App',
  components: {
    InputComponent,
    SubmitButton,
    Container,
    AppHeader,
    DropDown,
    Radio
  },
  setup() {
    const {
      experiancePercentage,
      yearsOfExperience,
      userProfession,
      selectedCity,
      selectedYear,
      onFormSubmit,
      yearsOption,
      cityOption,
      taxPercentage,
      baseSalary,
      selectedProfession,
      submitted,
      taxRate
    } = useSalary()

    return {
      experiancePercentage,
      selectedProfession,
      yearsOfExperience,
      userProfession,
      taxPercentage,
      selectedYear,
      onFormSubmit,
      selectedCity,
      yearsOption,
      baseSalary,
      cityOption,
      submitted,
      taxRate
    }
  }
})
